<app-breadcrumb
  [master]="'Rozliczenia'"
  [parentName]="'Faktury'"
  [name]="'Generator'">
</app-breadcrumb>

<div
  class="invoice-generator"
  [formGroup]="invoiceGeneratorForm"
  fxLayout="column"
  fxLayoutGap="15px">

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button
      type="button"
      mat-stroked-button
      color="primary"
      [class.spinner]="processingRequest"
      [disabled]="invoiceGeneratorForm.invalid || processingRequest || loadingPreparation || blockSubmit"
      (click)="save()">
      <span>Generuj fakturę</span>
    </button>

    <button
      type="button"
      mat-stroked-button
      [disabled]="processingRequest"
      (click)="resetForm()">
      <span> Wyczyść</span>
    </button>

    <button
      type="button"
      mat-stroked-button
      color="warn"
      [disabled]="processingRequest"
      (click)="cancel()">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-lg="100">
      <mat-card fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row">
          <h3>Dane faktury</h3>
        </div>

        <app-dict-all-contracts
          label="Umowa"
          [invoiceBlock]="true"
          [control]="contractControl"
          [required]="true"
          [showOwnerName]="true"
          [showStatus]="true"
          [invoiceGeneratorContractTypes]="true"
          (selectedContract)="contractChanged($event)">
        </app-dict-all-contracts>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="50" fxFlex.lt-md="100">
            <mat-label>Numer</mat-label>
            <input
              matInput
              required
              readonly
              placeholder="Numer faktury"
              [formControl]="numberControl">
            <mat-hint *ngIf="loadingPreparation">Pobieranie kolejnego numeru...</mat-hint>
            <mat-error *ngIf="numberControl.hasError('required')">
              Nie udało się ustalić numeru faktury
            </mat-error>
            <mat-error *ngIf="numberControl.hasError('backendError')">
              {{ numberControl.getError('backendError') }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="50" fxFlex.lt-md="100">
            <mat-label>Kwota</mat-label>
            <input
              matInput
              required
              type="number"
              min="0.01"
              step="0.01"
              placeholder="Kwota brutto"
              [formControl]="grossControl">
            <span matSuffix>&nbsp;zł</span>
            <mat-hint *ngIf="amountToPay !== null">
              Kwota do wypłaty:
              {{ amountToPay | number:'1.2-2' }} zł
            </mat-hint>
            <mat-error *ngIf="grossControl.hasError('required')">
              To pole jest wymagane
            </mat-error>
            <mat-error *ngIf="grossControl.hasError('min')">
              Kwota musi być większa od 0
            </mat-error>
            <mat-error *ngIf="grossControl.hasError('backendError')">
              {{ grossControl.getError('backendError') }}
            </mat-error>
            <mat-error
              *ngIf="grossControl.hasError('amountExceedsPayout')">

              Kwota faktury nie może przekraczać kwoty do wypłaty:
              {{ amountToPay | number:'1.2-2' }} zł
            </mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <app-datepicker
            fxFlex="50" fxFlex.lt-md="100"
            label="Data wystawienia"
            [required]="true"
            [control]="issueDateControl"
            placeholder="2000-01-01 00:00"
          ></app-datepicker>


          <app-month-picker
            fxFlex="50"
            fxFlex.lt-md="100"
            label="Miesiąc sprzedaży"
            [required]="true"
            [minSalesMonthLabel]="minSalesMonthLabel"
            [minDate]="minSalesMonth"
            [control]="salesMonthControl"
            [disabledDatePicker]="false"
            [readonly]="true">
          </app-month-picker>
        </div>

        <mat-form-field fxFlex="100">
          <mat-label>Numer rachunku bankowego</mat-label>
          <input
            matInput
            required
            readonly
            placeholder="Numer rachunku bankowego z umowy"
            [formControl]="bankAccountNumberControl">
          <mat-hint>Numer rachunku jest pobierany z wybranej umowy.</mat-hint>
          <mat-error *ngIf="bankAccountNumberControl.hasError('required')">
            Wybrana umowa nie ma uzupełnionego numeru rachunku bankowego
          </mat-error>
          <mat-error *ngIf="bankAccountNumberControl.hasError('backendError')">
            {{ bankAccountNumberControl.getError('backendError') }}
          </mat-error>
        </mat-form-field>
        <div fxLayout="row" *ngIf="blockSubmit">
          <span class="warning-text"> Partner posiada aktywną blokadę wystawiania faktur</span>
        </div>
        <mat-form-field fxFlex="100" *ngIf="!blockSubmit">
          <mat-label>Powód wygenerowania dokumentu</mat-label>
          <textarea
            matInput
            required
            rows="4"
            maxlength="1000"
            placeholder="Opisz powód wygenerowania faktury"
            [formControl]="reasonControl">
          </textarea>
          <mat-hint align="end">{{ reasonControl.value?.length || 0 }}/1000</mat-hint>
          <mat-error *ngIf="reasonControl.hasError('required')">
            Musisz podać powód wygenerowania dokumentu
          </mat-error>
          <mat-error *ngIf="reasonControl.hasError('maxlength')">
            Maksymalna długość to 1000 znaków
          </mat-error>
          <mat-error *ngIf="reasonControl.hasError('backendError')">
            {{ reasonControl.getError('backendError') }}
          </mat-error>
        </mat-form-field>
      </mat-card>
    </div>
    <ng-container
      *ngIf="
    selectedContract?.uuid &&
    selectedContract?.uuid === contractBalanceContract
  ">
      <div fxFlex="50" fxFlex.lt-lg="100">
        <mat-card fxLayout="column" fxLayoutGap="15px">
          <div fxFlex="100" class="mb-0"><h4>Saldo umowy: </h4></div>
          <div>
            <button (click)="addInitialBalance()" mat-stroked-button color="primary" class="add-button"
                    [disabled]="this.addInitialBalanceButton"><span>Dodaj saldo</span></button>
          </div>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
            <app-detail
              fxFlex="25"
              header="Saldo początkowe"
              [value]="">
              {{ (contractBalanceInitialBalanceNet == null
              ? 0
              : contractBalanceInitialBalanceNet) | number:'1.2-2' }} zł
            </app-detail>

            <app-detail
              fxFlex="25"
              header="Do wypłacenia"
              [value]="">
              {{ (contractBalanceToPayNet == null
              ? 0
              : contractBalanceToPayNet) | number:'1.2-2' }} zł
            </app-detail>

            <app-detail
              fxFlex="25"
              header="Wypłacono"
              [value]="">
              {{ (contractBalancePaid == null
              ? 0
              : contractBalancePaid) | number:'1.2-2' }} zł
            </app-detail>

            <app-detail
              fxFlex="25"
              header="Ogólne"
              [value]="">
              {{ (contractBalanceTotalCommission == null
              ? 0
              : contractBalanceTotalCommission) | number:'1.2-2' }} zł
            </app-detail>
          </div>

        </mat-card>
      </div>
    </ng-container>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button
      type="button"
      mat-stroked-button
      color="primary"
      [class.spinner]="processingRequest"
      [disabled]="invoiceGeneratorForm.invalid || processingRequest || loadingPreparation ||   blockSubmit"
      (click)="save()">
      <span>Generuj fakturę</span>
    </button>


    <button
      type="button"
      mat-stroked-button
      [disabled]="processingRequest"
      (click)="resetForm()">
      <span> Wyczyść</span>
    </button>


    <button
      type="button"
      mat-stroked-button
      color="warn"
      [disabled]="processingRequest"
      (click)="cancel()">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>
  </div>
</div>
